import React, { Component } from 'react';
import { observer } from 'mobx-react';
import authStore from '../../Auth/AuthStore';
import mainStore from '../../../MainStore';
import Rating from '@mui/material/Rating';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import FavoriteIcon from '@mui/icons-material/Favorite';
import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied';
import SentimentDissatisfiedIcon from '@mui/icons-material/SentimentDissatisfied';
import SentimentSatisfiedIcon from '@mui/icons-material/SentimentSatisfied';
import SentimentSatisfiedAltIcon from '@mui/icons-material/SentimentSatisfiedAltOutlined';
import SentimentVerySatisfiedIcon from '@mui/icons-material/SentimentVerySatisfied';
import PropTypes from 'prop-types';

//import TodoList from '@ckeditor/ckeditor5-list/src/todolist';
const customIcons = {
    1: {
        icon: <SentimentVeryDissatisfiedIcon />,
        label: 'Very Dissatisfied',
    },
    2: {
        icon: <SentimentDissatisfiedIcon />,
        label: 'Dissatisfied',
    },
    3: {
        icon: <SentimentSatisfiedIcon />,
        label: 'Neutral',
    },
    4: {
        icon: <SentimentSatisfiedAltIcon />,
        label: 'Satisfied',
    },
    5: {
        icon: <SentimentVerySatisfiedIcon />,
        label: 'Very Satisfied',
    }
};

function IconContainer(props) {
    const { value, ...other } = props;
    return <span {...other}>{customIcons[value].icon}</span>;
}

IconContainer.propTypes = {
    value: PropTypes.number.isRequired,
};

const VoteControl = observer(class VoteControl extends Component {
    constructor(props) {
        super(props);

        this.state = {
        };

        this.handleVote = this.handleVote.bind(this);
    }

    handleVote(evt, value) {
        var scope = this;
        mainStore.setMaskVisible();
        var token = localStorage.getItem("token");
        fetch('api/Suggestion/Vote', {
            method: 'POST',
            body: JSON.stringify({ suggestionId: this.props.suggestion.id, rate: value }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            }
        }).then(function (res) {
            if (res.status === 401) {
                authStore.openLogin();
                mainStore.setMaskUnvisible();
            }
            else {
                res.json().then((result) => {
                    mainStore.setMaskUnvisible();
                    if (scope.props.onVote) {
                        scope.props.onVote(result, value);
                    }
                    /*var suggestion = scope.props.work;
                    suggestion.rating = result.rating;
                    suggestion.myRate = value;
                    SuggestionsStore.updateSuggestion(suggestion);*/
                }).catch((err) => console.log(err));
            }
        });
    }

    getRateClass(rating) {
        if (rating > 10) return "best-rate";
        if (rating > 5) return "good-rate";
        if (rating >= 0) return "simple-rate";
        if (rating > -5) return "bad-rate";
        return "worst-rate";
    }

    getRateIconClass(rating) {
        if (rating === 5) return "best-rate-icon";
        if (rating === 4) return "good-rate-icon";
        if (rating === 3) return "simple-rate-icon";
        if (rating === 2) return "bad-rate-icon";
        if (rating === 1) return "worst-rate-icon";
        return "";
    }

    render() {
        return (
            <>
                <Rating
                    name={"customized-icons" + this.props.suggestion.id}
                    defaultValue={-1}
                    className={this.getRateIconClass(this.props.suggestion.myRate)}
                    value={this.props.suggestion.myRate}
                    onChange={this.handleVote}
                    getLabelText={(value) => customIcons[value].label}
                    IconContainerComponent={IconContainer}
                    disabled={this.props.suggestion.statusId !== '927daba8-fa6c-4858-be78-639524ecd395' && this.props.suggestion.statusId !== 'b7d01d88-8e96-47f1-959b-81189e71ed57'}
                />
                <div class="time-block">Проголосовало: {this.props.suggestion.voteCount}</div>    
            </>
        );
    }
});

export default VoteControl;